import './style.scss';

import React from 'react';
import { Loader, Title } from '@gjensidige/builders-components';

import { PageLoaderProps } from './types';

export const PageLoader: React.FC<PageLoaderProps> = ({
  loadingMessage
}: PageLoaderProps) => {
  return (
    <div className="page-loader-wrapper">
      <Loader size="lg">
        {!!loadingMessage && (
          <Title as="h2" size="5" className="loader-message">
            {loadingMessage}
          </Title>
        )}
      </Loader>
    </div>
  );
};
